import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export type PlanConsultationsResponse = {
  id: number;
  key: string;
  name: string;
  indicationLimit: number | null;
  userLimit: number | null;
  isSupportPriority: boolean;
  isExclusive: boolean;
  prices: {
    id: number;
    price: string;
  }[];
  consultations: {
    id: number;
    name: string;
    price: number;
  }[];
  digitalManagerOffer: {
    link: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class PlanPublicV2Service {
  url = environment.api_v2;

  constructor(private readonly http: HttpClient) {}

  public getConditions(): Observable<PlanConsultationsResponse[]> {
    return this.http
      .get<PlanConsultationsResponse[]>(`${this.url}/v2/plan-public/conditions`)
      .pipe(take(1));
  }

  public getConditionsByPlanId(planId: number) {
    return this.http
      .get<PlanConsultationsResponse>(
        `${this.url}/v2/plan-public/conditions/${planId}`
      )
      .pipe(take(1));
  }
}
